import { InputText } from 'primereact/inputtext';
import { Controller, useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { FieldErrorMessage } from '@features/campaigns/builder/components/FormFields/common/FieldErrorMessage/FieldErrorMessage.tsx';
import { FormFields } from '@features/users/adminPanel/components/FormFields/FieldTypes.ts';
import { FieldWrapper } from '@features/users/adminPanel/components/FormFields/FieldWrapper.tsx';
import { i18nNameSpace } from '@shared/consts/i18n.ts';

export function FieldInvoicingEmail() {
  const { t } = useTranslation(i18nNameSpace.USERS);
  const { control } = useFormContext();

  return (
    <FieldWrapper
      labelText={t('page.adminPanel.formFields.invoicingEmail.label')}
      fieldType={FormFields.INVOICING_EMAIL}
    >
      <Controller
        control={control}
        name={FormFields.INVOICING_EMAIL}
        render={({ field, formState: { errors } }) => {
          return (
            <>
              <InputText
                {...field}
                type='text'
                id={FormFields.INVOICING_EMAIL}
                placeholder={t('page.adminPanel.formFields.invoicingEmail.placeholder')}
              />
              {errors?.[FormFields.INVOICING_EMAIL] && (
                <FieldErrorMessage fieldErrorData={errors} fieldName={FormFields.INVOICING_EMAIL} />
              )}
            </>
          );
        }}
      />
    </FieldWrapper>
  );
}
